// extracted by mini-css-extract-plugin
export default {"tabPage":"PracticePageTab_tabPage__PPbYw","container":"PracticePageTab_container__e2fjB","pageTitle":"PracticePageTab_pageTitle__hxru8"};